import type {
  IDemo,
  IPresentation,
  ScreenResolution,
} from '@carboncopyco/types';
import { type TabGroup, TabType } from '@carboncopyco/types/desktop';
import { useTabManager } from '../../services/TabManager';

const useOpenDemoTab = () => {
  const { createGlobalTab } = useTabManager();

  return (
    demo: IDemo,
    options?: {
      tabTitle?: string;
      tabType?: TabType;
      forClient?: string;
      showWithoutDrafts?: boolean;
      firstUrl?: string;
      presentationId?: any;
      openFromInfoPage?: boolean;
      presentation?: IPresentation;
      organizationId?: string;
      demoId?: string;
      workspaceId?: string;
      folderId?: string;
      tourData?: {
        originalTourId?: number;
        insertIndex?: number;
        tourEditorTabId?: number;
      };
      screenResolution?: ScreenResolution;
      isOpenedFromEditor?: boolean;
      group?: TabGroup;
    }
  ) => {
    if (!demo.id) return;
    const url = decodeURIComponent(options?.firstUrl || demo.firstUrl);
    createGlobalTab({
      cloneId: demo.id.toString(),
      payload: {
        demo,
        presentation: options?.presentation ?? {
          id: options?.presentationId,
        },
        forClient: options?.forClient ?? '',
        showWithoutDrafts: options?.showWithoutDrafts ?? false,
        openFromInfoPage: options?.openFromInfoPage ?? false,
        isOpenedFromEditor: options?.isOpenedFromEditor ?? false,
        tourData: options?.tourData,
        screenResolution: options?.screenResolution,
      },
      organizationId: options?.organizationId,
      demoId: options?.demoId,
      workspaceId: options?.workspaceId,
      title: options?.tabTitle,
      hoverTitle: `${demo.demoName} for ${options?.forClient || ''}`,
      url,
      type: options?.tabType || TabType.PREVIEW_DEMO,
      folderId: options?.folderId,
      group: options?.group,
    });
  };
};

export default useOpenDemoTab;
